export default {
  common: {
    loading: 'Betöltés...',
    save: 'Mentés',
    cancel: 'Mégse',
    getStarted: 'Kezdjük',
  },
  nav: {
    home: 'Főoldal',
    features: 'Funkciók',
    pricing: 'Megoldások',
    contact: 'Kapcsolat',
  },
  hero: {
    title: 'YouCRM - Személyre szabott CRM megoldások',
    subtitle: 'Egyedi igényekre szabott CRM rendszerek az Ön vállalkozása számára',
    description: 'Unja már a drága és használhatatlan egyedi fejlesztéseket? A programozók ígérgetnek hónapok óta? Mobilon még mindig nem éri el a napi teendőit?',
    cta: 'Demó kérése',
  },
  features: {
    title: 'Főbb Funkciók',
    customerManagement: {
      title: 'Ügyfélkezelés',
      description: 'Könnyen kezelheti az ügyféladatbázisát és nyomon követheti az összes interakciót',
    },
    salesAutomation: {
      title: 'Értékesítési Automatizálás',
      description: 'Automatizálja értékesítési folyamatát és zárja gyorsabban az üzleteket',
    },
    reporting: {
      title: 'Fejlett Jelentések',
      description: 'Nyerjen betekintést vállalkozásába hatékony jelentéskészítő eszközökkel',
    },
    mobileFriendly: {
      title: 'Mobilbarát',
      description: 'Férjen hozzá CRM-jéhez bárhonnan, bármilyen eszközről',
    },
  },
  pricing: {
    title: 'Megoldásaink',
    subtitle: 'Az Ön vállalkozására szabva',
    basic: {
      name: 'Kisvállalkozás',
      price: 'Egyedi',
      period: 'árazás',
      description: 'Tökéletes kisvállalkozásoknak alapvető CRM igényekkel',
      features: [
        'Ügyfél adatbázis kezelés',
        'Alapvető jelentések',
        'Email támogatás',
        'Mobil hozzáférés',
      ],
    },
    pro: {
      name: 'Vállalkozás',
      price: 'Egyedi',
      period: 'árazás',
      description: 'Növekvő vállalkozásoknak fejlettebb igényekkel',
      features: [
        'Korlátlan ügyfél',
        'Fejlett jelentések',
        'Kiemelt támogatás',
        'API hozzáférés',
      ],
    },
    enterprise: {
      name: 'Nagyvállalat',
      price: 'Egyedi',
      period: 'árazás',
      description: 'Nagy szervezeteknek összetett követelményekkel',
      features: [
        'Teljesen testreszabott megoldás',
        'Egyedi jelentések',
        '24/7 támogatás',
        'Dedikált ügyfélmenedzser',
      ],
    },
  },
  contact: {
    title: 'Kapcsolat',
    subtitle: 'Kérjen demót vagy vegye fel a kapcsolatot csapatunkkal',
    name: 'Név',
    email: 'Email',
    message: 'Üzenet',
    send: 'Üzenet küldése',
    success: 'Üzenetét elküldtük. Hamarosan válaszolunk!',
    error: 'Hiba történt az üzenet küldése közben. Kérjük, próbálja újra.',
  },
  footer: {
    rights: 'Minden jog fenntartva',
    privacy: 'Adatvédelmi Szabályzat',
    terms: 'Felhasználási Feltételek',
  },
}; 